let env;
export const setupEnv = async (e) => {
    if (!["local", "development", "production"].includes(e)) {
        throw new Error(`unknown environment type: ${e}`);
    }
    env = e;
};
export const matchEnv = (matcher) => {
    if (!["local", "development", "production"].includes(env)) {
        throw new Error(`unknown environment type: ${env}`);
    }
    return matcher[env];
};
export const onlyLocal = (func) => {
    if (env === "local") {
        func();
    }
};
export const onlyProduction = (func) => {
    if (env === "production") {
        func();
    }
};
//# sourceMappingURL=env-matcher.js.map